<template>
  <b-select v-model="modelValue" :options="options" />
</template>
<script>
import { modelValue } from "@/mixins/modelValue";

export default {
  mixins: [modelValue("value", "change")],
  props: {
    value: {
      type: [String, Number],
      default: "pessoa_fisica",
    },
  },
  data() {
    return {
      options: [
        {
          text: "Pessoa Física",
          value: "pessoa_fisica",
        },
        {
          text: "Pessoa Jurídica",
          value: "pessoa_juridica",
        },
      ],
    };
  },
};
</script>
